class ContentWithSidenav {
  constructor(element) {
    this.contentWithSidenav = element;
    this.sidenavLinks = this.contentWithSidenav.querySelectorAll(
      "[data-content-with-sidenav-link]"
    );
    this.sections = this.contentWithSidenav.querySelectorAll(
      "[data-content-with-sidenav-heading]"
    );
    this.scrollIndicator = this.contentWithSidenav.querySelector(
      "[data-content-with-sidenav-indicator]"
    );

    this.setScrollListener();
  }

  setScrollListener() {
    window.addEventListener("scroll", () => {
      let currentActiveId = null;
      // Adjust this to account for fixed headers or other elements at the top.
      const headerOffset = 100;

      // Iterate backwards through the sections to find the last one that should be active.
      for (let i = this.sections.length - 1; i >= 0; i--) {
        const section = this.sections[i];
        const top = section.getBoundingClientRect().top;

        if (top - headerOffset < 0) {
          // Checks if the section has crossed the threshold to be considered active.
          currentActiveId = section.id;
          // Stop checking once we find the last section that has crossed the threshold.
          break;
        }
      }

      if (currentActiveId) {
        this.updateActiveLink(currentActiveId);
      }
    });
  }

  updateActiveLink(activeId) {
    this.sidenavLinks.forEach((link, i) => {
      if (link.getAttribute("href") === "#" + activeId) {
        link.classList.add("is-active");
        this.updateIndicatorPosition(i);
      } else {
        link.classList.remove("is-active");
      }
    });
  }

  updateIndicatorPosition(index) {
    this.scrollIndicator.style.setProperty("--sidenav-current-index", index);
  }
}

document.querySelectorAll("[data-content-with-sidenav]").forEach((element) => {
  new ContentWithSidenav(element);
});
